import { default as aggregate } from "./aggregate.json";
import { default as exportData } from "./export.json";
import { default as page1 } from "./page-1.json";
import { default as pointsHistoryData } from "./pointsHistory.json";

const data: { [key: string]: object } = {
  "aggregate": aggregate,
  "export": exportData,
  "page-1": page1,
  "pointsHistory": pointsHistoryData,
};

const events = {
  aggregate: () => data["aggregate"],
  export: () => data["export"],
  get: () => data["page-1"],
  pointsHistory: () => data["pointsHistory"],
};

export default events;
